import { getDatabase, ref, update } from 'firebase/database';
import { requireAdmin } from './adminGuard';
import { recordActivity } from './activityApi';
import { roofPlanCurrentBlueprintKeyPath } from '../Helpers/roofPlan';

/**
 * "Ta bort ritning" on the roof page: unsets `structure/roofPlan/currentBlueprintKey`
 * so no roof drawing is current. The drawing node and every marker position keyed
 * by it stay, exactly as an older drawing does after a replacement, so nothing is
 * lost and the Storage blob is never touched (file immutability + soft delete rules).
 */
export const clearRoofDrawing = async (buildingKey: string): Promise<void> => {
    const db = getDatabase();
    await requireAdmin(db, 'ta bort ritningar');
    try {
        await update(ref(db), { [roofPlanCurrentBlueprintKeyPath(buildingKey)]: null });
    } catch (error) {
        console.error('clearRoofDrawing failed:', error);
        throw new Error('Takritningen kunde inte tas bort');
    }
    recordActivity('drawing.deleted', { buildingKey });
};
